export default __webpack_public_path__ + "static/free-trial-bg-61fbad63501acdad005101a3edb100dd.svg";